import type { CapsuleLifecycleStatus } from 'new/modules/settings/capsules/domain/capsule.types';

/**
 * Maps arbitrary API status strings to a lifecycle for chips and consistent UI.
 */
export function parseLifecycleStatus(status: string | undefined): CapsuleLifecycleStatus {
  if (!status?.trim()) return 'inactive';
  const normalized = status.trim().toLowerCase();
  if (normalized === 'active') return 'active';
  if (normalized === 'pending') return 'pending';
  if (normalized === 'inactive') return 'inactive';
  return 'inactive';
}
